import { createContext, useContext } from 'react'

import { useAuthByPhone } from '../../hooks/use-auth-by-phone'

type AuthByPhoneContextValue = ReturnType<typeof useAuthByPhone>

const AuthByPhoneContext = createContext<AuthByPhoneContextValue | null>(null)

export const AuthByPhoneProvider = AuthByPhoneContext.Provider

export const useAuthByPhoneContext = () => {
	const value = useContext(AuthByPhoneContext)

	if (!value) {
		throw new Error('useAuthByPhoneContext must be used within AuthByPhone')
	}

	return value
}
